import React, { Fragment } from "react";
import ReactCreditCard from "react-credit-cards";
import { Control, Input } from "biologiatotal-ui";
import InputDefaultMask from "../../../components/inputMask";
import Form from "../../../components/form";
import { Checkbox } from "../../../components/checkbox";
import formSchema from "./schema";
import "react-credit-cards/es/styles-compiled.css";
import "./creditCard.scss";
import { getCurrencyFormat } from "../../../components/utils/currency";
// import NewSelect from "../../../profile/components/newSelect";

class CreditCard extends Form {
  constructor(props) {
    super(props, formSchema);

    this.state = {
      ...this.state
    };

    this.handleInputFocus = this.handleInputFocus.bind(this);
  }

  componentDidMount() {
    const { errors } = this.state;
    const { validadeErrosForm } = this.props;

    const errorsForm = Object.entries(errors).filter(([key, value]) => value || (key === "terms" && value === false))
      .length;

    validadeErrosForm(errorsForm);
  }

  componentDidUpdate(prevProps, prevState) {
    const { errors } = this.state;
    const { validadeErrosForm } = this.props;

    if (prevState.errors && prevState.errors !== errors) {
      const errorsForm = Object.entries(errors).filter(([key, value]) => value || (key === "terms" && value === false))
        .length;

      validadeErrosForm(errorsForm);
    }
  }

  handleInputFocus({ target }) {
    this.setState({
      ...this.state,
      focused: target.name
    });
  }

  doPay() {
    const { onPay } = this.props;

    // if (!values.terms) {
    //   this.setError("terms", "É obrigatório aceitar os termos de uso para assinar um plano");
    // } else {
    this.validate().then(() => {
      onPay(this.getValues());
    });
    // }
  }

  getInstallments = () => {
    const { installments } = this.props;
    const installmentsOptions = Object.entries(installments);

    return installmentsOptions.map(installment => {
      return { name: `${installment[0]}X de ${getCurrencyFormat(installment[1], "R$ ")}`, value: installment[0] };
    });
  };

  viaCep = cep => {
    const { doCepRequest } = this.props;

    if (cep.length === 10) {
      let cepReplaced = cep.replace(".", "");

      doCepRequest(cepReplaced)
        .then(json => {
          // Pega a cidade para os ceps que vem entre parenteses ex:(55165-000)
          const regExp = /\(([^)]+)\)/;
          const matches = regExp.exec(json.data.localidade);
          const localidade = matches ? matches[1] : json.data.localidade;

          this.update("cep", cepReplaced);
          this.update("address", json.data.logradouro);
          this.update("neighborhood", json.data.bairro);
          this.update("uf", json.data.uf);
          this.update("city", localidade);
        })
        .catch(err => {
          this.setError("cep", "CEP inválido");
        });
    }
  };

  render() {
    const { values, errors, focused } = this.state;
    const { installments, plan, isFetchingCep } = this.props;
    const installmentsOptions = Object.entries(installments);

    return (
      <Fragment>
        <div className="credit-card-info-inputs">
          <div className="credit-card-info-inputs-info">Campos obrigatórios</div>
        </div>
        <div className="credit-card">
          <div className="credit-card-left">
            <ReactCreditCard
              number={values.number}
              name={values.name}
              expiry={values.expiry}
              cvc={values.cvc}
              focused={focused}
              placeholders={{ name: "SEU NOME" }}
            />
          </div>

          <div>
            <Control className="credit-card-control column is-12">
              <InputDefaultMask
                type="text"
                label="Número do cartão:"
                name="number"
                mask={"9999 9999 9999 9999"}
                danger={!!errors.number}
                value={values.number}
                required={true}
                onFocus={this.handleInputFocus}
                onChange={e => this.update("number", e.target.value)}
                placeholder="0000 0000 0000 0000"
                className="credit-card-input"
              />
              <p className="credit-card-info help is-danger">{errors.number}</p>
            </Control>

            <Control className="credit-card-control column is-12">
              <span className={`credit-card-label input-required ${!!errors.name ? "error-input" : ""}`}>
                Nome impresso no cartão:
              </span>
              <Input
                type="text"
                name="name"
                danger={!!errors.name}
                value={values.name}
                onFocus={this.handleInputFocus}
                onChange={e => this.update("name", e.target.value)}
                placeholder="Nome impresso"
                className="credit-card-input"
              />
              <p className="credit-card-info help is-danger">{errors.name}</p>
            </Control>

            <div className="field is-horizontal">
              <Control className="credit-card-control credit-card-control-pdr column is-5">
                <InputDefaultMask
                  type="text"
                  label="Validade:"
                  name="expiry"
                  mask="99/99"
                  required={true}
                  danger={!!errors.expiry}
                  value={values.expiry}
                  onFocus={this.handleInputFocus}
                  onChange={e => this.update("expiry", e.target.value)}
                  placeholder="00/00"
                  className="credit-card-input"
                />
                <p className="credit-card-info help is-danger">{errors.expiry}</p>
              </Control>
              <Control className="credit-card-control credit-card-control-pdl column is-7">
                <InputDefaultMask
                  type="text"
                  label="Código de segurança:"
                  name="cvc"
                  mask="9999"
                  required={true}
                  danger={!!errors.cvc}
                  value={values.cvc}
                  onFocus={this.handleInputFocus}
                  onBlur={e => this.handleInputFocus({ target: "" })}
                  onChange={e => this.update("cvc", e.target.value)}
                  placeholder="000"
                  className="credit-card-input"
                />
                <p className="credit-card-info help is-danger">{errors.cvc}</p>
              </Control>
            </div>

            <Control className="credit-card-control column is-12">
              {/*<NewSelect*/}
              {/*  itens={installmentsOptions.length > 0 ? this.getInstallments() : []}*/}
              {/*  danger={!!errors.installments}*/}
              {/*  value={values.installments}*/}
              {/*  placeholder="Selecione"*/}
              {/*  onChange={value => {*/}
              {/*    this.update("installments", value.split("X")[0]);*/}
              {/*  }}*/}
              {/*  clasNames={`installments-input ${installmentsOptions.length === 0 ? "disabled" : ""} `}*/}
              {/*  classNameLabel={"assine-label"}*/}
              {/*  onboarding={""}*/}
              {/*  required={true}*/}
              {/*  reference={""}*/}
              {/*  label={"Em quantas parcelas?"}*/}
              {/*  classNameIcon={"credit-card-control-installments-input-icon arrow-assine"}*/}
              {/*/>*/}
              <p className="credit-card-info help is-danger">{errors.installments}</p>
            </Control>

            <Control className="credit-card-control column is-12">
              <InputDefaultMask
                type="text"
                label="CPF do titular do cartão?"
                mask={"999.999.999-99"}
                danger={!!errors.cpf}
                required={true}
                value={values.cpf}
                onChange={e => this.update("cpf", e.target.value)}
                placeholder="000.000.000-00"
                className="credit-card-input"
              />
              <p className="credit-card-info help is-danger">{errors.cpf}</p>
            </Control>

            <div className="field is-horizontal credit-card-mobile-control">
              <Control className="credit-card-control credit-card-control-pdr column is-8 is-8-mobile">
                <InputDefaultMask
                  type="text"
                  label="CEP:"
                  mask="99.999-999"
                  danger={!!errors.cep}
                  required={true}
                  value={values.cep}
                  loading={isFetchingCep ? "loading-mask" : ""}
                  onChange={e => this.viaCep(e.target.value)}
                  placeholder="00.000-000"
                />
                <p className="credit-card-info help is-danger">{errors.cep}</p>
              </Control>
              <Control className="credit-card-control credit-card-control-pdl  column is-4 is-4-mobile credit-card-control-cep">
                <a
                  title="não sei o CEP"
                  href={"http://www.buscacep.correios.com.br/sistemas/buscacep/"}
                  target={"_blank"}
                  className={" credit-card-control-cep-link"}>
                  não sei o CEP
                </a>
              </Control>
            </div>

            <Control className="credit-card-control column is-12">
              <span className={`credit-card-label input-required ${!!errors.address ? "error-input" : ""}`}>Rua:</span>
              <Input
                type="text"
                value={values.address}
                danger={!!errors.address}
                disabled={isFetchingCep ? "disabled" : ""}
                onChange={e => this.update("address", e.target.value)}
                placeholder="Nome da rua"
                className="credit-card-input"
                maxLength="60"
              />
              <p className="credit-card-info help is-danger">{errors.address}</p>
            </Control>

            <div className="field is-horizontal">
              <Control className="credit-card-control credit-card-control-pdr column is-4">
                <span className="credit-card-label not-required">Número:</span>
                <Input
                  type="text"
                  value={values.numberAddress}
                  danger={!!errors.numberAddress}
                  onChange={e => this.update("numberAddress", e.target.value)}
                  placeholder="000"
                  className="credit-card-input"
                  maxLength="9"
                />
                <p className="credit-card-info help is-danger">{errors.numberAddress}</p>
              </Control>

              <Control className="credit-card-control credit-card-control-pdl column is-8">
                <span className="credit-card-label not-required">Complemento:</span>
                <Input
                  type="text"
                  value={values.comp}
                  danger={!!errors.comp}
                  onChange={e => this.update("comp", e.target.value)}
                  placeholder="Complemento"
                  className="credit-card-input"
                  maxLength="30"
                />
                <p className="credit-card-info help is-danger">{errors.comp}</p>
              </Control>
            </div>

            <Control className="credit-card-control column is-12">
              <span className={`credit-card-label input-required ${!!errors.neighborhood ? "error-input" : ""}`}>
                Bairro:
              </span>
              <Input
                type="text"
                value={values.neighborhood}
                danger={!!errors.neighborhood}
                disabled={isFetchingCep ? "disabled" : ""}
                onChange={e => this.update("neighborhood", e.target.value)}
                placeholder="Bairro"
                className="credit-card-input"
                maxLength="50"
              />
              <p className="credit-card-info help is-danger">{errors.neighborhood}</p>
            </Control>

            <div className="field is-horizontal">
              <Control className="credit-card-control credit-card-control-pdr column is-4">
                <span className={`credit-card-label input-required ${!!errors.uf ? "error-input" : ""}`}>UF:</span>
                <Input
                  type="text"
                  value={values.uf}
                  danger={!!errors.uf}
                  disabled={isFetchingCep ? "disabled" : ""}
                  onChange={e => this.update("uf", e.target.value)}
                  placeholder="UF"
                  className="credit-card-input"
                  maxLength="2"
                  minLength="2"
                />
                <p className="credit-card-info help is-danger">{errors.uf}</p>
              </Control>

              <Control className="credit-card-control credit-card-control-pdl column is-8">
                <span className={`credit-card-label input-required ${!!errors.city ? "error-input" : ""}`}>
                  Cidade:
                </span>
                <Input
                  type="text"
                  value={values.city}
                  danger={!!errors.city}
                  disabled={isFetchingCep ? "disabled" : ""}
                  onChange={e => this.update("city", e.target.value)}
                  placeholder="Cidade"
                  className="credit-card-input"
                />
                <p className="credit-card-info help is-danger">{errors.city}</p>
              </Control>
            </div>

            {plan && plan.installment_count === 1 && (
              <Control className="credit-card-control column is-12">
                <Checkbox value={values.recurrence} onChange={value => this.update("recurrence", value)}>
                  Quero que a cobrança seja renovada automaticamente todos os meses
                  <span className="credit-card-msgrecurrence">
                    Isso significa que o valor de {getCurrencyFormat(plan.installment_value, "R$ ").replace(".", ",")}{" "}
                    será cobrado todos os meses
                  </span>
                </Checkbox>
              </Control>
            )}
          </div>
        </div>
      </Fragment>
    );
  }
}

CreditCard.displayName = "CreditCard";

export default CreditCard;
